import { styled } from 'styled-components';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { AdjustLinkService } from '../../../../new-lib/dynamic-link';
import { FormTypes } from '../../../../new-lib/constants/common';
import { Compound } from '../../../../new-lib/types/entity';

const ContactFormContainer = dynamic(
  () => import('../../../contact/components/organic-form/ContactFormContainer'),
  { ssr: false }
);

const ContactForm = ({ compound }: { compound: Compound }) => {
  const router = useRouter();
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const onFormSubmit = () => {
    if (isMobile) {
      AdjustLinkService.handleOpenApp();
    } else {
      router.push({
        pathname: `/search`,
        query: compound?.id ? { compounds: compound.id } : ''
      });
    }
  };
  return (
    <Container>
      <ContactFormContainer
        renderedInputs={{
          name: true,
          message: true,
          mobileNumber: true,
          location: true
        }}
        formSource={FormTypes.TOP_COMPOUNDS}
        onSubmit={onFormSubmit}
        location={{ compoundId: compound?.id?.toString() }}
        customEventName="NewTopCompounds"
        organizationId={
          compound?.nawyOrganizationId === 2
            ? compound.nawyOrganizationId
            : null
        }
      />
    </Container>
  );
};

const Container = styled.div`
  width: 50%;

  .contact-form {
    max-width: none;
    border-radius: 18px;
    background: #fbfcfe;
    box-shadow: 0px 0px 9px 0px rgba(26, 32, 40, 0.07);
    padding: 40px;
    form {
      max-width: none;

      #message {
        min-height: 150px;
      }

      button {
        border-radius: 100px;
        font-size: 18px;
        background-color: #015c9a;
      }
    }
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    width: 100%;
    .contact-form {
      padding: 16px;
      form {
        button {
          font-size: 16px;
        }
      }
    }
  }
`;

export default ContactForm;
